import { api } from '@here/api'

/**
 * Deletes a setup by its ID.
 * @param {string} id - The ID of the setup to delete.
 * @returns {Object|null} The deleted setup data, or null if deletion fails.
 */
export const getChannelHistoryAtId = async (
	activeChannelId?: string,
	focusMessageId?: string,
) => {
	if (!focusMessageId || !activeChannelId) {
		return
	}

	// Perform HTTP call to resolve the message plus message forward and backward from it
	const { data: resolvedMessage } = await api()
		.from('message')
		.select(`
				*,
				profile (
					username,
					last_seen (updated_at)
				),
        profile_private (
          role
        ),
				message_reaction (
					emoji,
					created_by,
					message_id
			)
			`)
		.eq('id', focusMessageId!)
		.single()
	if (resolvedMessage) {
		const { data: beforeMessages } = await api()
			.from('message')
			.select(`
				*,
				profile (
					username,
					last_seen (updated_at)
				),
        profile_private (
          role
        ),
				message_reaction (
					emoji,
					created_by,
					message_id
			)
			`)
			.eq('channel_id', activeChannelId!)
			.lt('created_at', resolvedMessage.created_at)
			.order('created_at', { ascending: false })
			.limit(10)
		const { data: afterMessages } = await api()
			.from('message')
			.select(`
				*,
				profile (
					username,
					last_seen (updated_at)
				),
        profile_private (
          role
        ),
				message_reaction (
					emoji,
					created_by,
					message_id
			)
			`)
			.eq('channel_id', activeChannelId!)
			.gt('created_at', resolvedMessage.created_at)
			.order('created_at', { ascending: true })
			.limit(10)

		const fullList = [
			...(beforeMessages || []).reverse(),
			resolvedMessage,
			...(afterMessages || []),
		]

		return fullList
	}
}
